"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConversation = void 0;
const core_1 = require("@zodios/core");
const zod_1 = __importDefault(require("zod"));
const conversation_1 = require("../core/conversation");
exports.createConversation = (0, core_1.makeEndpoint)({
    method: "post",
    path: "/app/conversation",
    alias: "createConversation",
    parameters: [
        {
            name: "body",
            type: "Body",
            schema: zod_1.default.object({
                voiceId: zod_1.default.string(),
            }),
        },
    ],
    response: conversation_1.conversationSchema,
});
//# sourceMappingURL=create.js.map